export const STAT_AURA_COLORS = Object.freeze({
  purple: '139, 86, 255',
  violet: '139, 86, 255',
  pink: '255, 98, 178',
  rose: '255, 98, 178',
  blood_red: '177, 14, 22',
  red: '198, 40, 40',
  crimson: '177, 14, 22',
  blue: '66, 133, 244',
  cyan: '38, 198, 218',
  green: '76, 175, 80',
  gold: '211, 172, 99',
  amber: '211, 172, 99',
})

export const STAT_AURA_FALLBACK_RGB = '211, 172, 99'

export const STAT_AURA_COLOR_OPTIONS = Object.freeze(
  Object.entries(STAT_AURA_COLORS).map(([key, rgb]) => ({ key, rgb }))
)

export function statAuraRgb(definitions, key) {
  const definition = (definitions || []).find(item => item?.id === key)
  return STAT_AURA_COLORS[definition?.color] || STAT_AURA_FALLBACK_RGB
}
